export const UserTypes = {
    STORE: 'Store',
    CUSTOMER: 'Customer',
    ADMIN_INVENTORY: 'AdminInventory'
};